module.exports = __webpack_public_path__ + "static/media/document.8fdfae02.svg";